var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.56 2.06L11.94.44A1.5 1.5 0 0010.878 0H5.5A1.5 1.5 0 004 1.5V3H1.5A1.5 1.5 0 000 4.5v10A1.5 1.5 0 001.5 16h7a1.5 1.5 0 001.5-1.5V13h2.5a1.5 1.5 0 001.5-1.5V3.121a1.5 1.5 0 00-.44-1.06zM11 1.016a.496.496 0 01.232.131l1.622 1.622a.488.488 0 01.13.232H11V1.015zM9 14.5a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-10a.5.5 0 01.5-.5H4v7.5A1.5 1.5 0 005.5 13H9v1.5zm4-3a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-10a.5.5 0 01.5-.5H10v2.25c0 .413.338.75.75.75H13v7.5z",
    fill: "#3555F0"
  })));
}

export default __webpack_public_path__ + "./fonts/clipboard.7762d457f25536cc9b06f3525623ec0f.svg";
export { SvgClipboard as ReactComponent };